/**
 * @file ProfileViewPage.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la página perfil de usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-07
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import TitleComponent from "@/components/ui/TitleComponent";
import { ProfileView } from "@/features/profile";
import { useTranslations } from "next-intl";
export const ProfileViewPage = () => {
  const $ = _c(7);
  const t = useTranslations("Routes");
  let t0;
  if ($[0] !== t) {
    t0 = t("profile");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TitleComponent title={t0} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProfileView />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};